// Runtime config injection (#1956).
//
// Build-once images can't rely on Vite's build-time `import.meta.env.VITE_*`
// inlining for per-host values (telemetry DSN differs between sandbox and
// production while the image bytes are identical). Instead, index.html loads
// /env.js BEFORE the bundle; the container entrypoint rewrites that file at
// startup from container env vars (XRING_PUBLIC_SENTRY_DSN / XRING_PUBLIC_ENV),
// setting `window.__XRING_CONFIG = { sentryDsn, env }` with empty/absent vars'
// keys omitted.
//
// Resolution order: window.__XRING_CONFIG wins; the build-time VITE_* value
// remains as the dev/vitest fallback; nothing set → telemetry disabled.

export function getRuntimeConfig() {
  return (typeof window !== "undefined" && window.__XRING_CONFIG) || {};
}

/** Sentry/GlitchTip DSN, or undefined → telemetry stays off. */
export function getSentryDsn() {
  return getRuntimeConfig().sentryDsn ?? import.meta.env.VITE_SENTRY_DSN;
}

/** Deployment environment label reported to telemetry. */
export function getTelemetryEnvironment() {
  return getRuntimeConfig().env ?? (import.meta.env.VITE_ENV || "production");
}
